export default __webpack_public_path__ + "static/media/bg2.f2844ecd.jpg";